/**
 * `FileUploadNewCallSource` exposes an API that the caller can use to upload
 * a file onto the server
 */
import api from '../api';

import FileUploadNewCallActions from 'actions/file-upload/FileUploadNewCallActions';
import interceptResponseAndArgs from 'utils/altjs/source';
import ConstValues from 'utils/const';

const interceptResponse = interceptResponseAndArgs([
  FileUploadNewCallActions.updateFileUploadMetadataSuccess,
]);

const FileUploadNewCallSource = {
  uploadFile: {
    remote(state, file) {
      let data = new FormData();
      data.append('file', file);
      return api.post('/upload_file', data, {
        onUploadProgress: progressEvent => {
          let progress = progressEvent.loaded / progressEvent.total;
          progress = Math.max(ConstValues.minFileUploadProgress, progress);
          FileUploadNewCallActions.uploadFileInProgress(progress);
        },
      });
    },
    error: FileUploadNewCallActions.uploadFileError,
    success: FileUploadNewCallActions.uploadFileSuccess,
  },
  updateFileMetadata: {
    remote(state, id, title, contact, original_filename, isSingleSpeakerCall) {
      return api.put(`/upload_file/${id}/metadata`, {
        title: title,
        contact: contact,
        original_filename: original_filename,
        is_single_speaker_call: isSingleSpeakerCall,
      });
    },
    interceptResponse: interceptResponse,
    error: FileUploadNewCallActions.updateFileUploadMetadataError,
    success: FileUploadNewCallActions.updateFileUploadMetadataSuccess,
  },
};

export default FileUploadNewCallSource;
